import React, {useState} from "react";
import {observer} from "mobx-react";
import {useTranslation} from "react-i18next";
import {AgreementsStore, AgreementsStoreContext} from "./agreements.store";
import {AgreementsController, AgreementsControllerContext} from "./agreements.controller";
import {Card, Col, Row, Skeleton} from "antd";
import {agreementsService} from "../../../services/agreements/agreements.service";
import {AgreementItem} from "./agreement-item/agreement.item";

export const Agreements: React.FC = observer(() => {
    const [store] = useState(() => new AgreementsStore());
    const [controller] = useState(() => new AgreementsController(store, agreementsService))

    return (
        <AgreementsStoreContext.Provider value={store}>
            <AgreementsControllerContext.Provider value={controller}>
                <Row className="row-no-margin" gutter={[20, 20]}>
                    {store.loading ? (
                        <Col className="card-col" xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                            <Card
                                className="card"
                                bordered={false}
                                size="small"
                                title={<Skeleton active paragraph={{rows: 1}}/>}
                            >
                                <Skeleton active paragraph={{rows: 2, width: "100%"}}/>
                            </Card>
                        </Col>
                    ) : store.agreements.map(item => (
                        <AgreementItem key={item.id} agreement={item}/>
                    ))}
                </Row>
            </AgreementsControllerContext.Provider>
        </AgreementsStoreContext.Provider>
    )
})